module.exports = __webpack_public_path__ + "static/post2-6cee5abf0e8fe625d6ad8c4849e4745e.png";